<template>
  <div>

    <div class="page-title-box">
      <div class="page-title-right">
        <a href="javascript:void(0)" class="btn btn-link" @click.prevent="showDeclarationImportModal" id="show-import-declaration-modal">
          <i class="mdi mdi-upload mr-1"></i><span>Impordi deklaratsioon</span>
        </a>
      </div>
      <h4 class="page-title">Deklaratsioonid</h4>
    </div>

    <div class="card">
      <div class="card-body bg-light pb-1">
        <b-form novalidate>
          <b-form-row>
            <div class="form-group col-6 col-lg-4 col-xl-2">
              <b-form-select v-model="filter.status" :options="statuses" size="sm" :class="{'form-control-highlighted': dirty('status')}"/>
            </div>
            <div class="form-group col-6 col-lg-4 col-xl-2">
              <b-form-select v-model="filter.direction" :options="directions" size="sm" :class="{'form-control-highlighted': dirty('direction')}"/>
            </div>
            <div class="form-group col-6 col-lg-4 col-xl-2">
              <b-form-select v-model="filter.invoiceNumberPrefix" :options="invoiceNumberPrefixes" value-field="code"
                             text-field="label" size="sm" :class="{'form-control-highlighted': dirty('invoiceNumberPrefix')}"/>
            </div>
            <div class="form-group col-6 col-lg-4 col-xl-3">
              <date-range-picker v-model="filter.dateRange" placeholder="Ajavahemik"
                                 class="input-group-sm" :class="{'form-control-highlighted': dirtyDateRange()}"/>
            </div>
            <div class="form-group col-6 col-lg-4 col-xl-2">
              <div class="input-group input-group-prepend-icon input-group-append-icon input-group-sm">
                <span class="input-group-prependable-icon mdi mdi-magnify"></span>
                <input @change="onQueryChanged" :value="filter.query" placeholder="Otsingusõna"
                       class="form-control" :class="{'form-control-highlighted': dirty('query')}">
                <a v-if="!!filter.query" @click="clearQuery" class="input-group-appendable-icon mdi mdi-close"></a>
              </div>
            </div>
            <div class="form-group col-6 col-lg-4 col-xl-1 d-flex align-items-center justify-content-center">
              <a @click="resetFilter" class="reset-filter text-secondary"><span class="mdi mdi-filter-remove"></span> Algseis</a>
            </div>
          </b-form-row>
          <b-form-row>
            <div class="col-6 mb-1">
              <b-form-checkbox v-model="filter.referencePrefix" :value="$store.state.user.declarationReferencePrefix"
                               :unchecked-value="null" :class="{'form-control-highlighted': dirty('referencePrefix')}">
                Ainult minu omad
              </b-form-checkbox>
            </div>
          </b-form-row>
        </b-form>
      </div>
      <div class="card-body">
        <declaration-list :filter="filter"/>
      </div>
    </div>

    <modal ref="showDeclarationImportModal" title="Deklaratsiooni importimine" size="lg">
      <declaration-import slot-scope="{close, visible}" @done="close" v-if="visible"/>
    </modal>

  </div>
</template>

<script>
  import Modal from '@/components/Modal'
  import DeclarationList from '../components/declaration/DeclarationList'
  import DeclarationImport from '../components/declaration/DeclarationImport'
  import DateRangePicker from '../components/DateRangePicker'
  import SearchFilterMixin from '../mixins/SearchFilterMixin'

  export default {
    mixins: [SearchFilterMixin],
    components: {Modal, DeclarationList, DateRangePicker, DeclarationImport},

    data() {
      return {
        defaultFilter: {
          status: 'filter_unconfirmed',
          direction: null,
          query: null,
          referencePrefix: null,
          invoiceNumberPrefix: null
        },
        filterPreviousState: this.$store.state.declarationFilter,
        filter: {},
        statuses: [{value: 'filter_unconfirmed', text: 'Kõik kinnitamata'}, {value: null, text: 'Kõik staatused'}],
        invoiceNumberPrefixes: [{code: null, label: 'Kõik objektid'}],
        directions: [{value: null, text: 'Kõik protseduurid'}, {value: 'IM', text: 'IM'}, {value: 'EX', text: 'EX'}, {value: 'EU', text: 'EU'}, {value: 'CO', text: 'CO'}]
      }
    },
    methods: {
      onQueryChanged(e) {
        this.filter.query = e.target.value === '' ? null : e.target.value
        if (this.filter.query) this.filter.status = null
      },
      clearQuery() {
        this.filter.query = null
      },
      showDeclarationImportModal() {
        this.$refs.showDeclarationImportModal.show()
      },
    },
    watch: {
      filter: {
        handler(filter) {
          this.$store.commit('declarationFilter', filter)
        },
        deep: true
      }
    },
    created() {
      this.$gateway.get('/configuration/declaration-statuses').then(r => this.statuses.splice(1, 0, ...r.data))
      this.$gateway.get('/configuration/invoice-prefixes').then(r => {
        this.invoiceNumberPrefixes.splice(0, 0, ...r.data)
      })
    }
  }
</script>
